import Message from "./messages"

export default {
  locales: ["en_GB"],
  messages: Message,
  formats: {},
  supportedLocales: [
    "ar_OM",
    "bg_BG",
    "zh_HK",
    "cz_CZ",
    "da_DK",
    "nl_NL",
    "en_GB",
    "fi_FI",
    "fr_FR",
    "de_DE",
    "hu_HU",
    "id_ID",
    "it_IT",
    "lv_LV",
    "lt_LT",
    "nb_NO",
    "pl_PL",
    "pt_BR",
    "ro_RO",
    "ru_RU",
    "sk_SK",
    "sl_SI",
    "es_PR",
    "sv_SE",
    "th_TH",
    "tr_TR",
    "uk_UA",
    "ur_PK",
  ],
}
